// Mock authentication service for local development
export interface AuthUser {
  userId: string;
  email: string;
  name: string;
  displayName: string;
  department: string;
  role: string;
  tenantId: string | null;
  lastLoginDate: string;
  isActive: boolean;
  isPendingSetup: boolean;
}

class MockAuthService {
  private getMockUser(): AuthUser {
    // Read role from localStorage for development testing
    const devRole = localStorage.getItem('dev_role') || 'TenantAdmin';
    const devUserId = localStorage.getItem('dev_user_id') || 'test-user-123';
    
    return {
      userId: devUserId,
      email: 'developer@local.dev',
      name: 'Local Developer',
      displayName: 'Local Developer',
      department: 'Development',
      role: devRole,
      tenantId: 'demo',
      lastLoginDate: new Date().toISOString(),
      isActive: true,
      isPendingSetup: false,
    };
  }

  async login(): Promise<boolean> {
    return true;
  }

  async getToken(): Promise<string | null> {
    return 'mock-jwt-token-for-local-development';
  }

  getUser(): AuthUser | null {
    return this.getMockUser();
  }

  async getUserAsync(): Promise<AuthUser | null> {
    return this.getMockUser();
  }

  isAuthenticated(): boolean {
    return true;
  }

  async logout(): Promise<void> {
    // No action needed for local development
  }

  async ensureAuthenticated(): Promise<boolean> {
    return true;
  }

  async refreshAuthenticationState(): Promise<boolean> {
    return true;
  }
}

export const mockAuthService = new MockAuthService();